import { createSlice } from '@reduxjs/toolkit';

const dialogSlice = createSlice({
  name: 'dialog',
  initialState: null,
  reducers: {
    open(_, action) {
      return action.payload;
    },
    close() {
      return null;
    },
  },
});

export const dialog = dialogSlice.actions;
export default dialogSlice.reducer;
